import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/router'
import About from './views/About/router'
import Creativity from './views/Creativity/router'
import Awards from './views/Awards/router'
import CategoryDetail from './views/Awards/CategoryDetail/router'
import News from './views/News/router'
import NewsDeatil from './views/News/Detail/router'
import Winners from './views/Winners/router'
import Archive from './views/Archive/router'
import WinnerArchive from './views/Archive/Winner/router'
import WinnerArchiveCategory from './views/Archive/Winner/List/router'
import WinnerArchiveDetail from './views/Archive/Winner/Detail/router'
import ProgramArchive from './views/Archive/Program/router'
import ProgramArchiveList from './views/Archive/Program/List/router'
import programArchiveDetail from './views/Archive/Program/Detail/router'

import DetailArchive from './views/Archive/Detail/router'
import ContentArchive from './views/Archive/Content/router'
import Gallery from './views/Gallery/router'
// import GalleryDemo from './views/GalleryDemo/router'
import Contact from './views/Contact/router'

import _Calendar from './views/_Calendar/router'

const Error = () => import('@/views/404')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    Home,
    About,
    Creativity,
    Awards,
    CategoryDetail,
    News,
    NewsDeatil,
    Winners,
    Archive,
    WinnerArchive,
    WinnerArchiveCategory,
    WinnerArchiveDetail,
    ProgramArchive,
    ProgramArchiveList,
    programArchiveDetail,
    DetailArchive,
    ContentArchive,
    Gallery,
    // GalleryDemo,
    Contact,
    _Calendar,
    {
      path: '*',
      component: Error
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
